import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import {
  rememberPostAuthReturn,
  shouldHandoffIncompleteOnboarding,
  WEB_SIGNUP_HANDOFF_PATH,
} from '../utils/onboardingHandoff';

export const PrivateRoute = ({ children }) => {
  const { user, token } = useAuth();
  const location = useLocation();

  // If we have a token but no user, it means we're still loading
  if (token && !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!token || !user) {
    // Redirect to login but save the attempted location. Router state alone
    // does not survive the landing page opening its login modal, so the path
    // is also kept for postAuthDestination to restore after sign-in.
    rememberPostAuthReturn(location);
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // #1221: web has no consumer onboarding — unfinished accounts finish in-app.
  if (shouldHandoffIncompleteOnboarding(location.pathname, user)) {
    return <Navigate to={WEB_SIGNUP_HANDOFF_PATH} replace />;
  }

  return children;
};